import * as types from './mutation-types'
import router  from "@/router"
const doLogin = async ({commit}, obj) => {
  const {email, password} = obj
  const params = {
    grant_type: 'password',
    client_id: process.env.API_CLIENT_ID,
    client_secret: process.env.API_CLIENT_SECRET,
    username: email,
    password: password,
    scope: '*'
  }
  const {access_token} = (await axios.post('/oauth/token', params)).data
  commit(types.SET_ACCESS_TOKEN, {access_token})
}

const doLogout = async ({commit}) => {
  await commit(types.REMOVE_ACCESS_TOKEN)
  await commit(types.REMOVE_REFRESH_TOKEN)
  router.push({name: 'auth.index'})
}

const setRedirect = ({commit}, obj) => {
  commit(types.REDIRECT, obj)
}

export default {
  doLogout,
  doLogin,
  setRedirect
}



// WEBPACK FOOTER //
// ./src/features/Auth/store/actions.js